export default __webpack_public_path__ + "static/media/twitch.a3ee6381.svg";